<template>
    <div class="userGuideCRUD">
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">{{ $t('table_title.Tutorial') }}</h5>
                            </a-col>
                        </a-row>
                    </template>
                    <template>
                        <v-data-table
                            :headers="tableColumns"
                            :items="tutorialList"
                            :loading="isLoadingTutorial"
                            :page="page"
                            :no-data-text="$t('cms.no_data_available')"
                            :single-expand="true"
                            class="elevation-1"
                            :loading-text="$t('cms.loading')"
                            hide-default-footer
                            show-expand
                        >
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-dialog v-model="dialogCU" persistent max-width="1000px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                color="primary"
                                                dark
                                                class="mb-2"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="onAddNewItem()"
                                                small
                                            >
                                                <v-icon small> mdi-plus </v-icon>
                                                {{ $t('cms.add_new') }}
                                            </v-btn>
                                        </template>
                                        <ModalTutorial
                                            :cuItem="cuItem"
                                            :closeCU="closeCU"
                                            :save="onSaveItem"
                                            :dialogEdit="dialogEdit"
                                            v-if="dialogCU"
                                        >
                                        </ModalTutorial>
                                    </v-dialog>
                                    <v-spacer></v-spacer>
                                    <v-dialog v-model="dialogDelete" max-width="500px">
                                        <ModalDelete :closeDelete="closeDelete" :deleteItemConfirm="deleteItemConfirm">
                                        </ModalDelete>
                                    </v-dialog>
                                    <v-dialog v-model="dialogNoti" max-width="500px">
                                        <ModalNoti :close="closeNoti" :message="formMessage"></ModalNoti>
                                    </v-dialog>

                                    <div class="search">
                                        <a-input-search
                                            v-model="search"
                                            :placeholder="$t('header.search')"
                                            @change="onSearchItem"
                                        />
                                    </div>
                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.title`]="{ item }">
                                <div class="my-2 line-clamp-2">
                                    <span>{{ item.title }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.created_at_unix_timestamp`]="{ item }">
                                <div class="my-2">
                                    <span>{{ convertTimeZone(+item.created_at_unix_timestamp) }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.updated_at_unix_timestamp`]="{ item }">
                                <div class="my-2">
                                    <span>{{ convertTimeZone(+item.updated_at_unix_timestamp) }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-btn color="info" class="mr-2" small @click="onUpdateItem(item)">
                                    <v-icon small> mdi-pencil </v-icon>
                                    &nbsp;{{ $t('form.edit') }}
                                </v-btn>
                                <v-btn color="error" dark class="mr-2" small @click="onDeleteItem(item)">
                                    <v-icon small> mdi-delete </v-icon>
                                    &nbsp;{{ $t('form.delete') }}
                                </v-btn>
                            </template>
                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length" class="tutorial-detail-table">
                                    <TutorialDetail :tutorial="item"></TutorialDetail>
                                </td>
                            </template>
                        </v-data-table>
                        <div class="text-center py-5">
                            <f-pagination
                                v-model="page"
                                :pageSize="tutorialPagination.pageSize"
                                :totalItems="tutorialPagination.totalItems"
                                :disabled="isLoadingTutorial"
                            />
                        </div>
                    </template>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import ModalTutorial from '../../components/CMS/Modal/Tutorial.vue';
import ModalDelete from '../../components/CMS/Modal/Delete.vue';
import ModalNoti from '../../components/CMS/Modal/Noti.vue';
import TutorialDetail from './TutorialDetail.vue';

import { CRUD } from '../../constants';
import { mixinToasts, mixinFormats, mixinLoadings } from '../../mixins';
import * as _ from 'lodash';

export default {
    mixins: [mixinToasts, mixinFormats, mixinLoadings],
    components: { ModalTutorial, ModalDelete, ModalNoti, TutorialDetail },
    data() {
        return {
            tableColumns: [
                { text: this.$t('form.title'), value: 'title', sortable: false, width: '300px' },
                {
                    text: this.$t('form.created_at'),
                    value: 'created_at_unix_timestamp',
                    sortable: false,
                    width: '175px',
                },
                {
                    text: this.$t('form.updated_at'),
                    value: 'updated_at_unix_timestamp',
                    sortable: false,
                    width: '175px',
                },
                { text: this.$t('cms.action'), value: 'actions', sortable: false, width: '210px' },
                { text: '', value: 'data-table-expand', width: '100px' },
            ],
            selectedField: 'title',
            search: '',
            page: 1,
            cuIndex: -1,
            cuItem: {},
            dialogCU: false,
            dialogDelete: false,
            dialogNoti: false,
            dialogEdit: false,
            formMessage: '',
        };
    },
    created() {},
    computed: {
        ...mapState('tutorial', ['isLoadingTutorial', 'tutorialList', 'tutorialPagination']),
        formTitle() {
            return this.cuIndex === -1 ? this.$t('action.new_question') : this.$t('action.edit_question');
        },
    },
    async mounted() {
        await this.getList({ page: this.page, field: this.selectedField, search: this.search });
    },
    watch: {
        page(val) {
            this.getList({ page: val, field: this.selectedField, search: this.search });
        },
        dialogCU(val) {
            val || this.closeCU();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
        dialogNoti(val) {
            val || this.closeNoti();
        },
    },
    methods: {
        ...mapActions('tutorial', ['getTutorialList', 'postTutorial', 'putTutorial', 'deleteTutorial']),

        async getList(data) {
            this.page = data?.page || 1;
            this.selectedField = data?.field || '';
            this.search = data?.search || '';
            await this.getTutorialList(data);
        },

        onAddNewItem() {
            this.dialogCU = true;
            this.dialogEdit = false;
        },

        onUpdateItem(item) {
            this.dialogCU = true;
            this.dialogEdit = true;
            this.cuIndex = this.tutorialList.indexOf(item);
            this.cuItem = Object.assign({}, item);
        },

        onDeleteItem(item) {
            this.dialogDelete = true;
            this.cuIndex = this.tutorialList.indexOf(item);
            this.cuItem = Object.assign({}, item);
        },

        closeCU() {
            this.dialogCU = false;
            this.dialogEdit = false;
            this.$nextTick(() => {
                this.cuItem = {};
                this.cuIndex = -1;
            });
        },

        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.cuItem = {};
                this.cuIndex = -1;
            });
        },

        closeNoti() {
            this.dialogNoti = false;
        },

        async deleteItemConfirm() {
            this.closeDelete();
            this.showLoading();
            const res = await this.deleteTutorial(this.cuItem.id);

            if (res?.isSuccess) {
                await this.getList({ page: this.page, field: this.selectedField, search: this.search });
                this.showSuccess(CRUD.DELETE);
            } else {
                this.showError(res?.message);
            }
            this.hideLoading();
        },

        async onSaveItem(data, callback) {
            let response = {};
            let getListParams = {};

            this.showLoading();

            if (this.cuIndex === -1) {
                response = await this.postTutorial(data);
                getListParams = { page: 1, field: this.selectedField, search: '' };
            } else {
                response = await this.putTutorial(data);
                getListParams = { page: this.page, field: this.selectedField, search: this.search };
            }

            callback(response?.isSuccess);
            if (response?.isSuccess) {
                await this.getList(getListParams);
                this.showSuccess(this.cuIndex === -1 ? CRUD.CREATE : CRUD.UPDATE);
            } else {
                this.showError(response?.message);
            }

            this.hideLoading();
        },

        onSearchItem: _.debounce(function (e) {
            this.getList({ page: 1, field: this.selectedField, search: this.search });
        }, 500),
    },
};
</script>

<style lang="scss">
.search {
    & .ant-input-search {
        width: 500px;
    }
}

.tutorial-detail-table {
    padding: 30px !important;
}
</style>
